<template>
  <div>
    <div
      id="duplicateConfirmation"
      style="z-index:99999 !important"
      class="modal fade custom"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header" style="font-weight: 600;">Confirm Duplicate</div>
          <div class="modal-body" style="padding: 0px;padding-bottom: 10px;padding-top: 20px;">
            <div class="container-fluid">
              <div
                class="col-md-12"
                style="font-weight: 500;"
              >Entered details contain duplicate data from an existing record. Do you want to continue?</div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-modal-footer cancel"
              style="float: left;background: #fff;"
              data-dismiss="modal"
            >
              <i class="fa fa-times-circle"></i> No, cancel
            </button>

            <button
              type="button"
              class="btn btn-export"
              style="background: #fff;float: right;"
              @click="proceedManualRegistration()"
              :disabled="loaderStatus"
            >
              <i class="fa fa-trash"></i> Yes, proceed
            </button>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from './Loader.vue';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      loaderStatus: false,
      errors: [],
    };
  },
  methods: {
    proceedManualRegistration() {
      $('#duplicateConfirmation').modal('hide');
      this.$emit('resetDuplicateFlag');
    },
  },
};
</script>
<style>
</style>
